import React, { FC, useEffect, useState } from "react";
import { Map } from "./Map";
import { MapViewModel } from "./MapViewModel.csharp";
import LazyLoad from "react-lazy-load";

export const MapContainer: FC<MapViewModel> = (props) => {
  return (
    <LazyLoad>
      <div className="body-text-container mb-4 mb-lg-5 mx-n2 mx-sm-0">
        {props.heading && (
          <h2 className="h3 mb-2 mb-md-3 mx-2 mx-sm-0">{props.heading}</h2>
        )}
        <div className="iframe-container map">
          <div className="iframe-container__inner map-container">
            <Map {...props} />
          </div>
        </div>
      </div>
    </LazyLoad>
  );
};
